export default __webpack_public_path__ + "874a968008f3c6125b209c774c038f66.wasm";